'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _reactRouter = require('react-router');

var _TermsHint = require('./TermsHint');

var _TermsHint2 = _interopRequireDefault(_TermsHint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./TermsAgreeLink.scss');

var TermsAgreeLink = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TermsAgreeLink, _Component);

  function TermsAgreeLink() {
    (0, _classCallCheck3.default)(this, TermsAgreeLink);
    return (0, _possibleConstructorReturn3.default)(this, (TermsAgreeLink.__proto__ || (0, _getPrototypeOf2.default)(TermsAgreeLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(TermsAgreeLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          className = _props.className;


      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: styles.links },
          _react2.default.createElement(
            'div',
            { className: styles.link },
            _react2.default.createElement(
              _reactRouter.Link,
              { target: '_blank', to: '/info/terms-of-service' },
              t('Terms of Service')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.link },
            _react2.default.createElement(
              _reactRouter.Link,
              { target: '_blank', to: '/info/privacy-policy' },
              t('Privacy Policy')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.link },
            _react2.default.createElement(
              _reactRouter.Link,
              { target: '_blank', to: '/info/cookie-policy' },
              t('Cookie Policy')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'text-center margin-top-10 colorDark' },
          _react2.default.createElement(_TermsHint2.default, null)
        )
      );
    }
  }]);
  return TermsAgreeLink;
}(_react.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = TermsAgreeLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/TermsAgreeLink.js
// module id = 1954
// module chunks = 1